import {BaseCachedService} from './Core/BaseCachedService';

class UserRoleService extends BaseCachedService {
    get Url() { return super.Url + "/userRoles"; }
    get ModelName() { return "UserRole"; }
    get PrimaryKeyProperty() { return "userRoleId"; }
    get TitleProperty() { return "name"; }
}

export const service = new UserRoleService();

